import { render, staticRenderFns } from "./DescargasActividadPantalla.vue?vue&type=template&id=a513a86e&"
import script from "./DescargasActividadPantalla.vue?vue&type=script&lang=ts&"
export * from "./DescargasActividadPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a513a86e', component.options)
    } else {
      api.reload('a513a86e', component.options)
    }
    module.hot.accept("./DescargasActividadPantalla.vue?vue&type=template&id=a513a86e&", function () {
      api.rerender('a513a86e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DescargaActividades/DescargasActividadPantalla.vue"
export default component.exports